import React from 'react';
import { Link } from 'react-router-dom';
import { adjacencyPages, legalLinks, navigationLinks, serviceList } from '../data/siteContent';

export default function Sitemap() {
  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-6xl mx-auto space-y-10">
        <header className="space-y-2 text-center">
          <p className="text-xs uppercase tracking-[0.6em] text-gray-500">Sitemap</p>
          <h1 className="text-4xl font-bold text-charcoal">Every page we hold for your team</h1>
          <p className="text-gray-600">Mirror the navigation inspired by Tax Strategy Center’s professional services layout.</p>
        </header>

        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <h2 className="text-lg font-semibold text-charcoal mb-3">Main Navigation</h2>
            <ul className="space-y-2 text-sm text-gray-600">
              {navigationLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-primary font-semibold">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-charcoal mb-3">Services</h2>
            <ul className="space-y-2 text-sm text-gray-600">
              {serviceList.map((service) => (
                <li key={service.slug}>
                  <Link to={`/services/${service.slug}`} className="text-primary font-semibold">
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-charcoal mb-3">Secondary Pages</h2>
            <ul className="space-y-2 text-sm text-gray-600">
              {[...adjacencyPages, ...legalLinks].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-primary font-semibold">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
